var map = {
	"./Buckaroo.png": 7092,
	"./Dropshipping.png": 2247,
	"./Inventoro.png": 4590,
	"./Storyous.png": 7620,
	"./banners/BuckarooMobile.png": 570,
	"./banners/BuckarooWeb.png": 7628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1565;